import React, { memo } from 'react';
import { Translate } from '@pegasus/translation';

import * as S from './campaign-overlay.styles';

interface CampaignOverlayProps {
    name: string;
    bannerText?: string;
    hoverClassName?: string;
}

export const CampaignOverlay: React.FC<CampaignOverlayProps> = ({
    name,
    bannerText,
    hoverClassName,
}) => (
    // TODO: Fix hover class.
    <S.Container className={hoverClassName}>
        <S.Wrapper>
            <S.InfoHeader>{name}</S.InfoHeader>
            <S.InfoBannerText>{bannerText}</S.InfoBannerText>
            <S.InfoBannerButton>
                <Translate message="campaigns.ctaButtonText" />
            </S.InfoBannerButton>
        </S.Wrapper>
    </S.Container>
);

export default memo(CampaignOverlay);
